module.exports = __webpack_public_path__ + "img/sennheiser.90472389.svg";